// TODO - Documentar
// Hooks for the diffetent transactions
import { useEffect, useMemo } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as con from "../../GlobalConstants"
import { filterObject, size } from '../../GlobalFunctions'
import { parseDate } from '../../utils/dateFunctions'
import { getFWDAssessmentData } from '../../utils/forwardFunctions'
import { allTransactionsCol, getFilterFunction, getSearchCompareFunction } from '../../utils/transactionFunctions'
import { RefApplicationParameterHook } from './ApplicationParametersHooks'
import { getOptionAssessmentData } from '../../utils/optionFunctions'
import { getCurrentLine } from '../../store/logic/supportFunctions'
import { RefUserAttributesHook } from './UserAttributesHook'
import { addAlert, deleteAlert, setTransactions } from '../../store/slices/transactionsSlice'
import { useForwardAssessmentFilterFun, useOptionAssessmentFilterFun } from './AssessmentHook'


/**
 * Hook for a single transactions in the store read only
 */
export function RefTransactionsHook(parameterName) {

    const value = useSelector(state => state[con.REDUCER_TRANSACTIONS][parameterName])

    return(value);
}

/**
 * Hook for a single transactions parameter in the store (read & write)
 */
export function StateTransactionsHook(parameterName) {
  const dispatch = useDispatch();

  const value = useSelector(
    (state) => state[con.REDUCER_TRANSACTIONS][parameterName]
  );

  const setParameter = (newVal) =>
    dispatch(
      setTransactions({
        id: parameterName,
        value: newVal,
      })
    );

  return [value, setParameter];
}

/**
 * Hook for a single transactions parameter in the store. Only write
 */
 export function EditTransactionsHook(parameterName) {
    const dispatch = useDispatch();
    const setParameter = (newVal) =>
      dispatch(
        setTransactions({
          id: parameterName,
          value: newVal,
        })
      );

    return(setParameter);
}

/**
 * Hook for a single nested transactions parameter in the store read only
 */
 export function RefNestedTransactionsHook(parameterName, attributeName) {

    const value = useSelector(state => state[con.REDUCER_TRANSACTIONS][parameterName][attributeName])

    return(value);
}

const EMPTY_OBJECT = {};

export const ExposuresHook = () => {
  return useSelector((state) =>
    state[con.REDUCER_TRANSACTIONS]?.byType?.[con.EXPOSURES] || EMPTY_OBJECT
  );
};

export const ForwardCoveragesHook = () => {
  return useSelector((state) =>
    state[con.REDUCER_TRANSACTIONS]?.byType?.[con.COVERAGES_FWD] || EMPTY_OBJECT
  );
}


export const SpotCoveragesHook = () => {
  return useSelector((state) =>
    state[con.REDUCER_TRANSACTIONS]?.byType?.[con.COVERAGES_SPOT] || EMPTY_OBJECT
  );
}

export const OptionCoveragesHook = () => {
  return useSelector((state) =>
    state[con.REDUCER_TRANSACTIONS]?.byType?.[con.COVERAGES_OPTION] || EMPTY_OBJECT
  );
}

export const AccountsHook = () => {
  return useSelector((state) =>
    state[con.REDUCER_TRANSACTIONS]?.byType?.[con.ACCOUNTS] || EMPTY_OBJECT
  );
}

export const CompensationAccountAmountHook = () => {
  const accounts = AccountsHook()
  return Object.values(accounts)
    .find(acc => acc[con.ACCOUNT_TYPE] === con.COMPENSATION_ACCOUNT)?.[con.AMOUNT] ?? 0
}

export const useTransactionAnnotations = (transID) => {
    const annotations = useSelector(
      state => state[con.REDUCER_TRANSACTIONS].annotationsByType[transID] ?? EMPTY_OBJECT
    )
    const getAnnotations = (rowID) => {
        const ann = annotations[rowID]
        return !ann ? [] : Array.isArray(ann) ? ann : Object.values(ann)
    }
    return getAnnotations
}

/**
 * Hook that reconstructs filter and search functions for transaction tables
 * from serialized parameters stored in Redux.
 *
 * @returns {{filterFun: Function, searchFun: Function}}
 */
export const useTransactionFilters = () => {

  const filterParams = RefTransactionsHook(con.FILTER_FUN_PARAMS)
  const searchParams = RefTransactionsHook(con.SEARCH_FUN_PARAMS)

  const filterFun = useMemo(() => {
    return getFilterFunction(filterParams)
  }, [filterParams])

  const searchFun = useMemo(() => {

    if (!searchParams) return con.DEFAULT_SEARCH_FUNCTION

    return getSearchCompareFunction(
      searchParams[con.COLUMN],
      searchParams[con.TYPE],
      searchParams[con.VALUE]
    )

  }, [searchParams])

  return { filterFun, searchFun }
}

export const TransactionColumnsHook = (selectedColumns, filterByBands) =>
{

    const selectedBand = RefApplicationParameterHook(con.SELECTED_BAND)

    const [usedColumns, setUsedColumns] = useState( () => selectedColumns.filter(col => !col[con.ID].includes("BAND") ||
                                                                                         !filterByBands ||
                                                                                         col[con.ID].includes(selectedBand))
                                                                          .map(col => {return({...allTransactionsCol[col[con.ID]], ...col})}))
    useEffect(() => {

        setUsedColumns(selectedColumns.filter(col => !col[con.ID].includes("BAND") ||
                                                !filterByBands ||
                                                col[con.ID].includes(selectedBand))
                                        .map(col => {return({...allTransactionsCol[col[con.ID]], ...col})}))

    }, [selectedColumns, filterByBands, selectedBand])


    return(usedColumns)
}


export const HasActivePurchases = (startDate, endDate, operation, clientType) =>
{
    const fwdCoverages = ForwardCoveragesHook()
    const spotCoverages = SpotCoveragesHook()
    const optionCoverages = OptionCoveragesHook()

    // Has purchases
    const [hasCoverages, setHasCoverages] = useState(() => false)

    useEffect(() => {

        let startDateOb = parseDate(startDate)
        let endDateOb = parseDate(endDate)
        let avSpot = {}

        if((clientType === con.IMPORTER && operation === con.BUY) || (clientType === con.EXPORTER && operation === con.SELL)){
            avSpot = filterObject(spotCoverages, (cov) => parseDate(cov[con.OPENING_DATE]) >= startDateOb && parseDate(cov[con.OPENING_DATE]) <= endDateOb)
        }

        let avFwd = filterObject(fwdCoverages, (cov) => parseDate(cov[con.OPENING_DATE]) >= startDateOb && parseDate(cov[con.OPENING_DATE]) <= endDateOb && cov[con.COVERAGE_TYPE] === operation)
        let avOption = filterObject(optionCoverages, (cov) => parseDate(cov[con.OPENING_DATE]) >= startDateOb && parseDate(cov[con.OPENING_DATE]) <= endDateOb && cov[con.COVERAGE_TYPE] === operation)

        setHasCoverages(size(avFwd) > 0 || size(avSpot) > 0 || size(avOption) > 0)

    }, [fwdCoverages, spotCoverages, optionCoverages, startDate, endDate, operation, clientType])

    return(hasCoverages)

}


export const AssessedForwardCoveragesHook = () =>
{
    
    // Forwards
    const forwards = ForwardCoveragesHook()

    // Rate
    const forward_assessment_rate = RefApplicationParameterHook(con.FORWARD_ASSESSMENT_RATE)

    // Reference Date
    const referenceDate = RefApplicationParameterHook(con.FORWARD_ASSESSMENT_REFERENCE_DATE)

    // FWD filter Function
    const fwd_assessment_filter_fun = useForwardAssessmentFilterFun()

    // Current Line
    const userline = getCurrentLine();

    const setLoading = EditTransactionsHook(con.LOADING_CURRENT_TRANSACTIONS)

    const default_summary = useMemo(() => ({
        [con.ACTIVE_FWD_AMOUNT]: 0,
        [con.AVERAGE_FWD_RATE]: 0,
        [con.ASSESSMENT_RATE]: 0,
        [con.PORTFOLIO_ASSESSMENT]: 0
    }), []);

    const [assessedFwd, setAssessedFwd] = useState({});
    const [assessmentSummaries, setAssessmentSummaries] = useState(default_summary);
    
    useEffect(() => {
        const fetchFWDAssessmentData = async () => {
            try {
                const forward_list = Object.values(forwards).filter(fwd => fwd_assessment_filter_fun(fwd));
                if (forward_list.length >= 1 && forward_list[0][con.USER_LINE] === Number(userline)) {
                    setLoading(true)
                    const data = { forward_list, referenceDate, forward_assessment_rate };
                    const response = await getFWDAssessmentData(data);
                    if (response) {
                        const responseData = response[con.DATA][con.DATA];
                        const transformedData = responseData[con.COVERAGES_FWD].reduce((acc, obj) => {
                            acc[obj.id] = obj;
                            return acc;
                        }, {});
                        setAssessedFwd(transformedData);
                        setAssessmentSummaries(responseData[con.SUMMARY]);
                    }
                } else {
                    setAssessedFwd({});
                    setAssessmentSummaries(default_summary)
                }
            } catch (error) {
                console.error('Error fetching FWD Assessment data:', error);
            } finally {
                setLoading(false)
            }
        };

        fetchFWDAssessmentData();
       // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forwards, fwd_assessment_filter_fun, referenceDate, forward_assessment_rate, userline, default_summary]);

    return([assessedFwd, assessmentSummaries])    
}

export const AssessedOptionCoveragesHook = () => {
    
    // Options
    const options = OptionCoveragesHook()

    // USDCOP Rate to valuing options 
    const option_assessment_rate = RefApplicationParameterHook(con.OPTION_ASSESSMENT_RATE)

    // Reference Date
    const referenceDate = RefApplicationParameterHook(con.OPTION_ASSESSMENT_REFERENCE_DATE)

    // Option Filter Function
    const option_assessment_filter_function = useOptionAssessmentFilterFun()

    // Current Line
    const userline = getCurrentLine();

    const setLoading = EditTransactionsHook(con.LOADING_CURRENT_TRANSACTIONS)

    
    // Assessment Summary
    const default_summary = useMemo(() => ({
      [con.ACTIVE_OPTION_AMOUNT] : 0,
      [con.ASSESSMENT_RATE] : 0,
      [con.PREMIUM_GAINS] : 0,
      [con.PORTFOLIO_ASSESSMENT] : 0,
      [con.TOTAL_ASSESSMENT] : 0
    }), []);
    
    // Assessed Options Coverages
    const [assessedOptionsCoverages, setAssessedOptionsCoverages] = useState({})
    const [assessmentSummary, setAssessmentSummary] = useState(default_summary)


    // Updates Assessed Coverages
    useEffect(() => {
        const fetchFWDAssessmentData = async () => {
            try {
                const option_list = Object.values(options).filter(op => option_assessment_filter_function(op));
                if (option_list.length >= 1 && option_list[0][con.USER_LINE] === userline) {
                    setLoading(true)
                    const data = { option_list, referenceDate, option_assessment_rate };
                    const response = await getOptionAssessmentData(data);
                    if (response) {
                        const responseData = response[con.DATA][con.DATA];
                        const transformedData = responseData[con.COVERAGES_OPTION].reduce((acc, obj) => {
                            acc[obj.id] = obj;
                            return acc;
                        }, {});
                        setAssessedOptionsCoverages(transformedData);
                        setAssessmentSummary(responseData[con.SUMMARY]);
                    } else {
                        setAssessedOptionsCoverages({})
                        setAssessmentSummary(default_summary)
                    }
                }
            } catch (error) {
                console.error('Error fetching Option Assessment data:', error);
            } finally {
                setLoading(false)
            }
        };

        fetchFWDAssessmentData();
       // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options, option_assessment_filter_function, referenceDate, option_assessment_rate, userline, default_summary]);

    return([assessedOptionsCoverages, assessmentSummary])
}

// ------------------------------------------------------
// ALERTS HOOKS
// ------------------------------------------------------

export const RefAlertsHook = () => {
  return useSelector((state) =>
    state[con.REDUCER_TRANSACTIONS][con.MARKET_ALERTS]
  );
}

export const useAlertsPagination = (alerts, alertsPerPage = 5) => {

  const [currentPage, setCurrentPage] = useState(1)

  const totalPages = Math.ceil(alerts.length / alertsPerPage)

  const currentAlerts = useMemo(() => {

    const start = (currentPage - 1) * alertsPerPage
    const end = start + alertsPerPage

    return alerts.slice(start, end)

  }, [alerts, currentPage, alertsPerPage])

  const nextPage = () =>
    setCurrentPage(p => Math.min(p + 1, totalPages))

  const prevPage = () =>
    setCurrentPage(p => Math.max(p - 1, 1))

  const firstPage = () =>
    setCurrentPage(1)

  const lastPage = () =>
    setCurrentPage(totalPages)

  return {
    currentPage,
    totalPages,
    currentAlerts,
    nextPage,
    prevPage,
    firstPage,
    lastPage
  }
}

export const useAddAlert = () => {

  const dispatch = useDispatch();
  const userId = RefUserAttributesHook(con.USER);

  const addAlertHandler = async ({ alert_type, level }) => {

    const parsedLevel = parseFloat(level);

    if (isNaN(parsedLevel)) {
      throw new Error("Level must be a valid number");
    }

    dispatch(
      addAlert({
        user: userId,
        alert_type,
        level: parsedLevel
      })
    );
  };

  return addAlertHandler;
};


export const useDeleteAlert = () => {

  const dispatch = useDispatch();

  const deleteAlertHandler = (alertId) => {
    dispatch(deleteAlert(alertId));
  };

  return deleteAlertHandler;
};